<template>
    <LoadingState :loading="loadingWallet" />
    <div :class="{ relative: showAccountSidebar }">
        <div>
            <div
                class="flex-none w-full sm:px-6 lg:px-8 lg:py-8"
                :class="{
                    'account-sidebar-open': showAccountSidebar,
                    'account-sidebar-closed': !showAccountSidebar,
                }"
            >
                <!-- Page header -->
                <div class="flex justify-between items-center mb-5 lg:mb-10">
                    <!-- Left: Title -->
                    <div class="">
                        <h1
                            class="text-2xl md:text-3xl text-gray-800 font-bold"
                        >
                            My Wallet
                        </h1>
                    </div>

                    <!-- Right: Actions -->
                    <div
                        class="flex flex-col sm:flex-row sm:items-center justify-start sm:justify-end gap-2"
                    >
                        <a
                            href="#"
                            @click.prevent="setShowAffiliateModal(true)"
                            class="link-base link-10x-orange"
                            id="hs-wallet-affiliate-disclosure"
                        >
                            Affiliate Disclosure
                        </a>
                        <a
                            href="#"
                            @click.prevent="openConnectModal"
                            class="btn-base btn-10x-orange"
                            role="button"
                            id="hs-wallet-add-account"
                        >
                            <svg
                                class="w-3 h-3 flex-shrink-0"
                                viewBox="0 0 16 16"
                                fill="currentColor"
                            >
                                <path
                                    d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z"
                                />
                            </svg>
                            Add Account
                        </a>
                    </div>
                </div>
                <!-- END PAGE HEADER -->

                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12 lg:col-span-6 xl:col-span-8">
                        <ul
                            :class="
                                width > 768
                                    ? 'pill-list mb-3'
                                    : 'mobile-pill-list'
                            "
                        >
                            <li class="shadow-none border-none">
                                <add-wallet-user-btn></add-wallet-user-btn>
                            </li>
                            <li v-if="this.width > 768">
                                <a
                                    class="pill !text-xs lg:!text-sm"
                                    id="hs-wallet-show-all-cards"
                                    v-bind:class="{
                                        dark: allShowUsers === users.length,
                                    }"
                                    href="#"
                                    @click.prevent="toggleUsersShown('A')"
                                >
                                    All Cards
                                    <span class="counter">
                                        {{ nonHiddenCardsCount }}
                                    </span>
                                </a>
                            </li>
                            <li
                                v-if="
                                    this.users.length > 1 && this.width <= 768
                                "
                                class="users-dropdown"
                            >
                                <Listbox as="div" v-model="selectedUser">
                                    <ListboxLabel
                                        class="block text-sm font-medium leading-6 text-gray-900"
                                    >
                                        Users
                                    </ListboxLabel>
                                    <div class="relative">
                                        <ListboxButton
                                            class="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-orange sm:text-sm sm:leading-6"
                                        >
                                            <span class="block truncate">
                                                {{
                                                    selectedUser
                                                        ? selectedUser.name
                                                        : 'All Users'
                                                }}
                                            </span>
                                            <span
                                                class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
                                            >
                                                <i
                                                    class="fa-light fa-angles-up-down"
                                                    style="color: #334154"
                                                ></i>
                                            </span>
                                        </ListboxButton>

                                        <transition
                                            leave-active-class="transition ease-in duration-100"
                                            leave-from-class="opacity-100"
                                            leave-to-class="opacity-0"
                                        >
                                            <ListboxOptions
                                                class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-sm border border-slate-200 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                                            >
                                                <!-- all users option  -->
                                                <ListboxOption
                                                    :value="null"
                                                    v-slot="{
                                                        active,
                                                        selected,
                                                    }"
                                                >
                                                    <li
                                                        :class="[
                                                            active
                                                                ? 'bg-orange text-white'
                                                                : 'text-gray-900',
                                                            'flex items-center relative cursor-default select-none py-2 pl-3 pr-9',
                                                        ]"
                                                        @click="
                                                            selectedUser = null
                                                        "
                                                    >
                                                        <span
                                                            :class="[
                                                                selected
                                                                    ? 'font-semibold'
                                                                    : 'font-normal',
                                                                'truncate',
                                                            ]"
                                                        >
                                                            All Users
                                                        </span>
                                                        <span
                                                            v-if="!selectedUser"
                                                            :class="[
                                                                !selectedUser
                                                                    ? 'text-white'
                                                                    : 'text-orange',
                                                                'absolute inset-y-0 right-0 flex items-center pr-4',
                                                            ]"
                                                        >
                                                            <i
                                                                class="fa-light fa-check"
                                                                style="
                                                                    color: #334154;
                                                                "
                                                                aria-hidden="true"
                                                            ></i>
                                                        </span>
                                                    </li>
                                                </ListboxOption>
                                                <!-- all other options  -->
                                                <ListboxOption
                                                    as="template"
                                                    v-for="puser in pillUsers"
                                                    :key="
                                                        'pkey-' +
                                                        puser.user_type
                                                    "
                                                    :value="puser"
                                                    v-slot="{
                                                        active,
                                                        selected,
                                                    }"
                                                >
                                                    <li
                                                        :class="[
                                                            active
                                                                ? 'bg-orange text-white'
                                                                : 'text-gray-900',
                                                            'flex items-center relative cursor-default select-none py-2 pl-3 pr-9',
                                                        ]"
                                                        @click="
                                                            handleSelectUser(
                                                                puser
                                                            )
                                                        "
                                                    >
                                                        <span
                                                            :class="[
                                                                selected
                                                                    ? 'font-semibold text-blue'
                                                                    : 'font-normal text-red',
                                                                'block, truncate',
                                                            ]"
                                                        >
                                                            {{ puser.name }}
                                                        </span>
                                                        <span
                                                            class="counter text-xs ml-1"
                                                        >
                                                            ({{
                                                                userAccountCount(
                                                                    puser
                                                                )
                                                            }})
                                                        </span>
                                                        <span
                                                            v-if="
                                                                selectedUser &&
                                                                selectedUser.id ===
                                                                    puser.id
                                                            "
                                                            :class="[
                                                                selectedUser.id ===
                                                                puser.id
                                                                    ? 'text-white'
                                                                    : 'text-orange',
                                                                'absolute inset-y-0 right-0 flex items-center pr-4',
                                                            ]"
                                                        >
                                                            <i
                                                                class="fa-light fa-check"
                                                                style="
                                                                    color: #334154;
                                                                "
                                                                aria-hidden="true"
                                                            ></i>
                                                        </span>
                                                    </li>
                                                </ListboxOption>
                                            </ListboxOptions>
                                        </transition>
                                    </div>
                                </Listbox>
                            </li>
                            <li
                                v-for="puser in pillUsers"
                                v-else
                                :key="'pkey-' + puser.user_type"
                            >
                                <a
                                    class="pill"
                                    v-bind:class="{
                                        dark:
                                            puser.show &&
                                            puser.institutions.length > 0 &&
                                            allShowUsers !== users.length,
                                        'cursor-not-allowed':
                                            puser.institutions.length === 0,
                                    }"
                                    href="#"
                                    @click.prevent="toggleUsersShown(puser)"
                                    id="hs-wallet-show-users-cards"
                                >
                                    {{ puser.name }}
                                    <span class="counter">
                                        {{ userAccountCount(puser) }}
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div
                        class="col-span-12 lg:col-span-6 xl:col-span-4"
                        v-show="allCardsCount > 0"
                    >
                        <div class="flex justify-end text-right">
                            <div
                                class="relative flex justify-center items-center"
                                v-click-outside="closeFilters"
                            >
                                <div
                                    class="inline-flex items-center mr-5 my-2 mb-3"
                                >
                                    <span class="text-xs">Show Card #s</span>
                                    <Switch
                                        :value="showLastFour"
                                        @input="showLastFour = $event"
                                        label="Show Last 4"
                                        id="hs-wallet-show-last-four"
                                    />
                                </div>

                                <a
                                    v-if="hasConnections"
                                    href="/wallet/members"
                                    class="link-base link-dark mr-6"
                                    id="hs-wallet-manage-connections"
                                >
                                    <i
                                        class="fas fa-cog text-orange hover:text-orange-light text-lg"
                                    ></i>
                                    Manage Connections
                                </a>

                                <a
                                    href="#"
                                    @click.prevent="filtersOpen = !filtersOpen"
                                    aria-haspopup="true"
                                    :aria-expanded="filtersOpen"
                                    role="button"
                                    class="btn-icon btn-white"
                                    id="hs-wallet-filters"
                                >
                                    <span
                                        v-if="filterCount > 0"
                                        class="text-white mr-3 text-xs font-bold bg-black p-1 rounded-full w-5 h-5 min-w-5 text-center inline-flex flex-col leading-none items-center justify-center"
                                    >
                                        {{ filterCount }}
                                    </span>
                                    <span class="sr-only">Filter</span>
                                    <svg
                                        class="w-4 h-4 fill-current"
                                        viewBox="0 0 16 16"
                                    >
                                        <path
                                            d="M9 15H7a1 1 0 010-2h2a1 1 0 010 2zM11 11H5a1 1 0 010-2h6a1 1 0 010 2zM13 7H3a1 1 0 010-2h10a1 1 0 010 2z"
                                        ></path>
                                    </svg>
                                </a>
                                <div
                                    class="origin-top-right z-10 absolute top-full right-0 min-w-44 bg-white border border-gray-200 pt-1.5 rounded shadow-lg overflow-hidden mt-1"
                                    v-show="filtersOpen"
                                >
                                    <div
                                        class="text-xs font-semibold text-gray-400 uppercase pt-1.5 pb-2 px-4"
                                    >
                                        Filters
                                    </div>

                                    <ul class="mb-4">
                                        <li class="py-1 px-3">
                                            <label class="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    class="form-checkbox"
                                                    :checked="
                                                        filters.all_cards.includes(
                                                            'Y'
                                                        )
                                                    "
                                                    @change="
                                                        toggleFilter(
                                                            'all_cards',
                                                            'Y'
                                                        )
                                                    "
                                                />
                                                <span
                                                    class="inline-block ml-2 font-base text-sm"
                                                >
                                                    All Cards
                                                </span>
                                            </label>
                                        </li>
                                        <li class="py-1 px-3">
                                            <label class="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    class="form-checkbox"
                                                    :class="{
                                                        'opacity-40':
                                                            filters.ignore,
                                                    }"
                                                    :checked="
                                                        filters.account_type.includes(
                                                            'personal'
                                                        )
                                                    "
                                                    @change="
                                                        toggleFilter(
                                                            'account_type',
                                                            'personal'
                                                        )
                                                    "
                                                    :disabled="filters.ignore"
                                                />
                                                <span
                                                    class="inline-block ml-2 font-base text-sm"
                                                    :class="{
                                                        'opacity-40':
                                                            filters.ignore,
                                                    }"
                                                >
                                                    Personal
                                                </span>
                                            </label>
                                        </li>
                                        <li class="py-1 px-3">
                                            <label class="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    class="form-checkbox"
                                                    :class="{
                                                        'opacity-40':
                                                            filters.ignore,
                                                    }"
                                                    :checked="
                                                        filters.account_type.includes(
                                                            'business'
                                                        )
                                                    "
                                                    @change="
                                                        toggleFilter(
                                                            'account_type',
                                                            'business'
                                                        )
                                                    "
                                                    :disabled="filters.ignore"
                                                />
                                                <span
                                                    class="inline-block ml-2 font-base text-sm"
                                                    :class="{
                                                        'opacity-40':
                                                            filters.ignore,
                                                    }"
                                                >
                                                    Business
                                                </span>
                                            </label>
                                        </li>
                                        <li class="py-1 px-3">
                                            <label class="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    class="form-checkbox"
                                                    :class="{
                                                        'opacity-40':
                                                            filters.ignore,
                                                    }"
                                                    :checked="
                                                        filters.card_status.includes(
                                                            'open'
                                                        )
                                                    "
                                                    @change="
                                                        toggleFilter(
                                                            'card_status',
                                                            'open'
                                                        )
                                                    "
                                                    :disabled="filters.ignore"
                                                />
                                                <span
                                                    class="inline-block ml-2 font-base text-sm"
                                                    :class="{
                                                        'opacity-40':
                                                            filters.ignore,
                                                    }"
                                                >
                                                    Open
                                                </span>
                                            </label>
                                        </li>
                                        <li class="py-1 px-3">
                                            <label class="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    class="form-checkbox"
                                                    :class="{
                                                        'opacity-40':
                                                            filters.ignore,
                                                    }"
                                                    :checked="
                                                        filters.card_status.includes(
                                                            'closed'
                                                        )
                                                    "
                                                    @change="
                                                        toggleFilter(
                                                            'card_status',
                                                            'closed'
                                                        )
                                                    "
                                                    :disabled="filters.ignore"
                                                />
                                                <span
                                                    class="inline-block ml-2 font-base text-sm"
                                                    :class="{
                                                        'opacity-40':
                                                            filters.ignore,
                                                    }"
                                                >
                                                    Closed
                                                </span>
                                            </label>
                                        </li>
                                        <li class="py-1 px-3">
                                            <label class="flex items-center">
                                                <input
                                                    type="checkbox"
                                                    class="form-checkbox"
                                                    v-model="filters.ignore"
                                                    @change="
                                                        toggleFilter(
                                                            'ignore',
                                                            true
                                                        )
                                                    "
                                                />
                                                <span
                                                    class="inline-block ml-2 font-base text-sm"
                                                >
                                                    Hidden
                                                </span>
                                            </label>
                                        </li>
                                    </ul>
                                    <div
                                        class="py-2 px-3 border-t border-gray-200 bg-gray-50"
                                    >
                                        <ul
                                            class="flex items-center justify-end"
                                        >
                                            <li>
                                                <button
                                                    class="btn-base btn-white !max-h-6"
                                                    @click.prevent="
                                                        clearFilters
                                                    "
                                                    style="outline: none"
                                                    id="hs-wallet-clear-filters"
                                                >
                                                    Clear
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <WalletUser
                    v-for="user in userAccounts"
                    v-if="!loadingWallet"
                    :wallet="wallet"
                    :user="user"
                    :key="'wu-' + user.id"
                    :filters="filters"
                    :show="user.show"
                    @update-card-data="updateCardData"
                    @openConnectModal="openConnectModalAction"
                    @clearFilters="clearFilters"
                />
            </div>

            <AccountSidebar :user="selectedUser" />
        </div>

        <EditCardModal
            :card="selectedCard"
            :user="selectedUser"
            :users="users"
            :cards="cards"
            :wallet="wallet"
            :banks="banks"
            @close="closeModal"
            @update="updateCardData"
            v-if="showEditCardModal"
        />

        <CopyCardDetailsModal
            v-if="showCopyCardModal"
            :show="showCopyCardModal"
            :source-card="{ card: selectedCard, user: selectedUser }"
            @close="closeCopyCardModal"
        />

        <ConnectModal
            :wallet="wallet"
            :showAddCardModal="showAddCardModal"
            :setFinshedSyncAccount="setFinshedSyncAccount"
            :setFixUnresolved="setFixUnresolved"
            :setHowToAddCard="setHowToAddCard"
            :cards="cards"
            :users="allUsers"
            :banks="banks"
            :step="connectStep"
            :activeUser="activeUser"
            @finished="finishedConnect"
            @close="closeConnectModal"
            @addedCard="addedCard"
        />

        <add-wallet-user-modal @addedUser="addedUser"></add-wallet-user-modal>

        <unmatched-modal
            v-show="showUnmatchedModal"
            @close="closeUnmatchedModal"
            :unmatchCount="unmatchCount"
        ></unmatched-modal>

        <div
            class="modal"
            aria-labelledby="add-card-modal-title"
            role="dialog"
            aria-modal="true"
            v-if="showDefaultManualRewardsCreated"
        >
            <div class="modal-overlay" aria-hidden="true"></div>
            <div class="inner">
                <div class="modal-body items-start p-8 border">
                    <p class="mb-5">
                        We created {{ createdProgram.program.name }} program
                        from your {{ createdProgram.card.title }} connection. At
                        this time, we can't automatically sync these rewards,
                        but you can manually maintain them.
                    </p>
                    <div class="text-center">
                        <button
                            class="btn-base btn-dark"
                            @click="showDefaultManualRewardsCreated = false"
                            id="hs-wallet-accept-manual-rewards"
                        >
                            OK!
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3';
import Switch from '@/components/ui/switch/switch.vue';
import ConnectModal from '@/components/wallet/modals/connect.vue';
import AddWalletUserModal from '@/components/wallet/modals/add-wallet-user.vue';
import EditCardModal from '@/components/wallet/modals/edit-card.vue';
import UnmatchedModal from '@/components/wallet/modals/unmatched-modal.vue';
import WalletUser from '@/components/wallet/wallet-user.vue';
import AccountSidebar from '@/components/wallet/account-sidebar.vue';
import AddWalletUserBtn from '@/components/wallet/add-wallet-user-btn.vue';
import LoadingState from '../ui/loading-state/loading-state.vue';
import CopyCardDetailsModal from '@/components/wallet/modals/copy-card-details.vue';

import { mapState, mapActions } from 'pinia';
import { useWalletStore } from '@/store/wallet';
import { useAppStore } from '@/store/app';
import {
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
} from '@headlessui/vue';

export default {
    props: [],
    components: {
        Switch,
        LoadingState,
        ConnectModal,
        AddWalletUserModal,
        EditCardModal,
        UnmatchedModal,
        WalletUser,
        AccountSidebar,
        AddWalletUserBtn,
        Listbox,
        ListboxButton,
        ListboxLabel,
        ListboxOption,
        ListboxOptions,
        CopyCardDetailsModal,
    },
    directives: {
        ClickOutside: vClickOutside.directive,
    },
    data: () => ({
        width: document.documentElement.clientWidth,
        errors: [],
        loadingWallet: false,
        showAddCardModal: false,
        setFinshedSyncAccount: false,
        setFixUnresolved: false,
        showUnmatchedModal: false,
        setHowToAddCard: '',
        itemsCount: 0,
        currentPage: 1,
        connectStep: 1,
        unmatchCount: 0,
        userName: '',
        syncedAccounts: [],
        activeUser: {},
        institution: '',
        filtersOpen: false,

        showDefaultManualRewardsCreated: false,
        createdProgram: {
            program: { name: '' },
            card: {
                title: '',
            },
        },
    }),
    computed: {
        ...mapState(useWalletStore, [
            'wallet',
            'walletId',
            'myWallet',
            'showAccountSidebar',
            'hasConnections',
            'users',
            'banks',
            'cards',
            'filters',
            'showEditCardModal',
            'selectedCard',
            'selectedUser',
            'showCopyCardModal',
        ]),
        ...mapState(useAppStore, ['userSettings']),

        allCardsCount() {
            let count = 0;
            this.users.forEach((n, v) => {
                n.institutions.forEach((el) => {
                    el.accounts.forEach((acct) => {
                        count += 1;
                    });
                });
            });
            return count;
        },
        filteredCardsCount() {
            return this.userAccounts.reduce((total, user) => {
                return (total += user.numFilteredCards);
            }, 0);
        },
        nonHiddenCardsCount() {
            let count = 0;
            this.users.forEach((n, v) => {
                n.institutions.forEach((el) => {
                    el.accounts.forEach((acct) => {
                        if (!acct.ignore) {
                            count += 1;
                        }
                    });
                });
            });
            return count;
        },
        userAccounts() {
            return this.users.map((user) => {
                let institutions = user.institutions.reduce((acc, ins) => {
                    if (!ins.accounts.length) {
                        return acc;
                    } else {
                        let filteredAccounts = ins.accounts.filter((obj) => {
                            const cardType = obj.card ? obj.card.type : '';
                            if (this.filters.all_cards.includes('Y')) {
                                return true;
                            } else {
                                let status = true;
                                let type = true;

                                if (
                                    this.filters.card_status.length > 0 &&
                                    !this.filters.card_status.includes(
                                        obj.card_status
                                    )
                                ) {
                                    status = false;
                                }
                                if (
                                    this.filters.account_type.length > 0 &&
                                    !this.filters.account_type.includes(
                                        cardType
                                    )
                                ) {
                                    type = false;
                                }

                                if (this.filters.ignore) {
                                    return obj.ignore === this.filters.ignore;
                                } else {
                                    return obj.card && status && type;
                                }
                            }
                        });

                        acc.push({
                            ...ins,
                            cards: filteredAccounts,
                        });
                        return acc;
                    }
                }, []);

                const numFilteredCards = institutions.reduce(
                    (total, currIns) => {
                        return (total += currIns.cards.length);
                    },
                    0
                );

                return {
                    ...user,
                    institutions,
                    numFilteredCards,
                };
            });
        },

        pillUsers() {
            return this.users.length > 1 ? this.users : [];
        },
        allUsers() {
            return this.users.filter((v) => {
                return v.show;
            });
        },
        allShowUsers() {
            return this.users.reduce(function (n, v) {
                return n + (v.show === true);
            }, 0);
        },
        showLastFour: {
            get() {
                return this.userSettings.show_last_four;
            },
            set(val) {
                this.setShowLastFour(val);
            },
        },
        filterCount() {
            return (
                this.filters.card_status.length +
                this.filters.account_type.length
            );
        },
    },
    watch: {
        showEditCardModal(val) {
            if (!val) {
                this.errors = [];
            }
        },
    },
    methods: {
        ...mapActions(useWalletStore, [
            'setWallet',
            'setWalletId',
            'getWallet',
            'setShowEditCardModal',
            'setSelectedCard',
            'setSelectedUser',
            'resetFilters',
            'setFilters',
            'removeFilter',
            'setShowCopyCardModal',
            'clearAccountToEdit',
        ]),
        ...mapActions(useAppStore, [
            'setShowAffiliateModal',
            'setWallet',
            'setAppWalletId',
            'setShowLastFour',
        ]),
        async getData() {
            this.loadingWallet = true;
            await this.getWallet();
            setTimeout(() => {
                this.loadingWallet = false;
            }, 500);

            this.setAppWalletId(this.walletId);
        },
        updateCardData() {
            this.getWallet();
        },
        closeCardActionsDropdown() {
            this.users.forEach((uitem) => {
                uitem.institutions.forEach((ins, ii) => {
                    ins.accounts.forEach((uel) => {
                        uel.actionsOpen = false;
                    });
                });
            });
            setTimeout(() => {
                this.$forceUpdate();
            }, 100);
        },
        toggleUsersShown(user) {
            if (user === 'A') {
                this.users.forEach((v) => {
                    v.show = true;
                });
                this.selectedUser = '';
            } else {
                this.users.forEach((v) => {
                    v.show = false;
                });
                user.show = true;
            }
        },
        handleSelectUser(user) {
            this.setSelectedUser(user);
            this.toggleUsersShown(user);
        },
        selectAllRows(user) {
            user.cards.forEach((v) => {
                v.rowSelected = user.allRowsSelected;
            });
        },
        selectRow(item) {
            item.rowSelected = item.rowSelected ? true : false;
        },
        toggleAllRows(user) {
            user.cards.forEach((v) => {
                v.rowOpen = user.allRowsToggle;
            });
        },
        toggleFilter(key, value) {
            if (key === 'ignore') {
                if (this.filters.ignore) {
                    this.setFilters('all_cards', []);
                    this.setFilters('card_status', []);
                    this.setFilters('account_type', []);
                }
            } else if (this.filters[key].includes(value)) {
                const index = this.filters[key].indexOf(value);
                this.removeFilter(key, index);
            } else {
                if (key === 'all_cards') {
                    this.setFilters('card_status', []);
                    this.setFilters('account_type', []);
                } else {
                    this.filters.all_cards = [];
                    this.setFilters('all_cards', []);
                }
                this.setFilters(key, [...this.filters[key], value]);
            }

            if (
                this.filters.card_status.length === 0 &&
                this.filters.account_type.length === 0 &&
                !this.filters.ignore
            ) {
                this.setFilters('all_cards', ['Y']);
            }
        },
        //get the number of non-hidden cards for a user:
        userAccountCount(puser) {
            let count = 0;
            puser.institutions.forEach((ins) => {
                ins.accounts.forEach((acct) => {
                    count += !acct.ignore ?? 1;
                });
            });

            return count;
        },

        addedUser() {},
        clearFilters() {
            this.resetFilters();
        },
        closeUnmatchedModal() {
            this.showUnmatchedModal = false;
        },
        closeModal(modal) {
            this.setShowEditCardModal(false);
            this.addCardStep = 1;
            if (modal === 'showEditCardModal') {
                this.clearSelectedData();
            }
        },
        clearSelectedData() {
            this.setSelectedCard(null);
            this.setSelectedUser(null);
        },
        finishedConnect() {
            this.showAddCardModal = false;
            this.connectStep = 1;
            this.setFinshedSyncAccount = false;
            this.setFixUnresolved = false;
            this.setHowToAddCard = '';
        },
        openConnectModal() {
            this.connectStep = 1;
            this.setFinshedSyncAccount = false;
            this.setFixUnresolved = false;
            this.setHowToAddCard = '';
            this.showAddCardModal = true;
        },
        openConnectModalAction(data) {
            this.activeUser = data;
            this.openConnectModal();
        },
        addedCard() {
            this.getData();
            this.showAddCardModal = false;
        },
        closeConnectModal() {
            this.showAddCardModal = false;
        },
        closeFilters() {
            this.filtersOpen = false;
        },
        getDimensions() {
            this.width = document.documentElement.clientWidth;
        },
        checkHash() {
            if (location.hash && location.hash === '#add-account') {
                this.openConnectModal();
                history.pushState(
                    '',
                    document.title,
                    window.location.pathname + window.location.search
                );
            }
        },
        checkUnresolvedCards() {
            if (
                this.wallet.unresolved_cards &&
                this.wallet.unresolved_cards.length > 0
            ) {
                this.unmatchCount = this.wallet.unresolved_cards.length;
                if (
                    !this.$cookies.get('matchaccounts') ||
                    this.wallet.has_new_accounts
                ) {
                    this.showUnmatchedModal = true;
                }
            }
        },
        checkForCardToEdit() {
            console.log('Checking for card to edit...');
            // Use the same specific localStorage key
            const storageKey = '10x_temp_account_to_edit';

            // Try to get and parse the data
            try {
                const storedData = localStorage.getItem(storageKey);

                // If we have data, parse it and validate
                if (storedData) {
                    console.log('Found stored data:', storedData);
                    // Clear it immediately to prevent it from being used again
                    localStorage.removeItem(storageKey);

                    const data = JSON.parse(storedData);

                    // Validate the data structure
                    if (
                        !data ||
                        !data.guid ||
                        !data.timestamp ||
                        data.source !== 'connection_card'
                    ) {
                        console.warn('Invalid account edit data structure');
                        return;
                    }

                    // Check if the data is expired (older than 30 seconds)
                    const now = Date.now();
                    const maxAge = 30 * 1000; // 30 seconds in milliseconds

                    if (now - data.timestamp > maxAge) {
                        console.warn('Account edit request expired');
                        return;
                    }

                    // Data is valid and not expired, use the GUID
                    const accountGuid = data.guid;

                    // Find the account in the wallet data
                    let foundAccount = null;

                    // Search through all users, institutions, and accounts to find the account by guid
                    this.users.forEach((user) => {
                        user.institutions.forEach((institution) => {
                            institution.accounts.forEach((account) => {
                                if (account.guid === accountGuid) {
                                    foundAccount = account;
                                }
                            });
                        });
                    });

                    // If we found the account, open the edit modal
                    if (foundAccount) {
                        this.setSelectedCard(foundAccount);
                        this.setShowEditCardModal(true);
                        return true;
                    }
                }
            } catch (error) {
                console.error('Error processing account edit data:', error);
                // Make sure to clear the storage key in case of error
                localStorage.removeItem(storageKey);
            }
            return false;
        },

        closeCopyCardModal() {
            this.setSelectedCard(null);
            this.setSelectedUser(null);
            this.setShowCopyCardModal(false);
        },
    },
    created() {},
    mounted() {
        window.addEventListener('resize', this.getDimensions);

        this.getData().then(() => {
            const editingCard = this.checkForCardToEdit();
            if (!editingCard) {
                this.checkUnresolvedCards();
            }
        });
        this.checkHash();
    },
    unmounted() {
        window.removeEventListener('resize', this.getDimensions);
    },
};
</script>
<style lang="scss" scoped>
.account-sidebar-open {
    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-448px);
}
.account-sidebar-closed {
    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(0);
}
.annual-fee-label-trigger {
    &:hover {
        .annual-fee-label {
            display: block;
        }
    }
}
.annual-fee-label {
    display: none;
    width: 200px;
    padding: 6px 12px;
    color: #fff;
    background-color: #1c293d;
    border-radius: 4px;
    position: absolute;
    bottom: 110%;
    left: 50%;
    margin-left: -100px;
}
.fadeOut-enter-active,
.fadeOut-leave-active {
    transition: opacity 0.8s;
}
.fadeOut-enter,
.fadeOut-leave-to {
    opacity: 0;
}
</style>
